export class ServiceOrder {
  id?: number;
  resourceTypeId?: number | null;
  resourceName?: string | null;
  resourceCode?: string | null;
  resourceUnitOfMeasure?: string | null;
  activityId?: number | null;
  activityName?: string | null;
  serviceOrderPlannedQuantity?: number | null;
  serviceOrderId?: number | null;
  standId?: number | null;
  standName?: string | null;
  propertyId?: string | null;
  propertyName?: string | null;
  regionId?: number | null;
  regionName?: string | null;
  stageId?: number | null;
  stageName?: string | null;
  vendorId?: number | null;
  vendorName?: string | null;
  appliesPercentage?: boolean;
  percentageToApply?: number;
  standLatitude?: number | null;
  standLongitude?: number | null;
  serviceOrderStandActivityId?: number | null;

  constructor(dto?: Partial<ServiceOrder>) {
    Object.assign(this, dto);
  }
}
